import { SortOrderTypeFavoriteItems } from "enums";
import { ItemSearchOptions } from "models";
import React, { useEffect } from "react";

type PROPS = {
  options: ItemSearchOptions;
  onChange: () => void;
};

const FavoriteItemSearchSortSelect: React.FC<PROPS> = (props) => {
  const [sortOrder, setSortOrder] = React.useState<string>("");

  useEffect(() => {
    const tmp = props.options.sort_order ?? "";
    setSortOrder(tmp);
  }, [props.options.sort_order]);

  return (
    <select
      className="border border-gray-600 rounded py-2 cursor-pointer"
      value={sortOrder}
      onChange={(e) => {
        const value = e.target.value;
        props.options.sort_order = value;
        setSortOrder(value);

        props.onChange();
      }}
    >
      <option value={SortOrderTypeFavoriteItems.ADD_DATE_NEW}>
        追加日が新しい順
      </option>
      <option value={SortOrderTypeFavoriteItems.ADD_DATE_OLD}>
        追加日が古い順
      </option>
      <option value={SortOrderTypeFavoriteItems.PRICE_LOW}>価格が低い順</option>
      <option value={SortOrderTypeFavoriteItems.PRICE_HIGH}>
        価格が高い順
      </option>
    </select>
  );
};

export default FavoriteItemSearchSortSelect;
